var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictureAlbum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 73,
    viewBox: "0 0 54 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2715 72.0001L1 48.7355L27.7225 33.9153L46.5132 58.7063L24.2715 72.0001Z",
    fill: "#E2664C",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.2715 72.0001L1 48.7355L27.7225 33.9153L46.5132 58.7063L24.2715 72.0001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5656 54.4246L22.2897 67.6405L1.22882 44.7695L22.5048 31.5513L43.5656 54.4246Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9969 54.1544L22.3984 66.3291L2.79755 45.0394L22.3961 32.8647L41.9969 54.1544Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5066 39.5037C27.8953 39.9721 27.3801 40.5541 26.9894 41.2177C25.6346 43.6161 29.1451 48.907 27.4929 50.2435C25.8406 51.58 20.0484 48.7972 18.1101 52.0308C16.7599 54.2758 17.4121 58.871 17.9385 61.4753L22.4079 66.3292L42.0064 54.1522L28.5066 39.5037Z",
    fill: "#E2664C",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4791 46.1081C13.2092 46.8999 13.0993 47.9778 12.2343 48.5155C11.3692 49.0533 10.0785 48.8451 9.34849 48.0578C8.61847 47.2706 8.72603 46.1859 9.59107 45.6481C10.4561 45.1103 11.7491 45.314 12.4791 46.1081Z",
    fill: "#E2664C",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4783 56.0059L24.4908 67.1279L6.89008 38.6524L26.8776 27.5281L44.4783 56.0059Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0835 55.459L24.6704 65.7045L8.2872 39.1994L26.7003 28.9539L43.0835 55.459Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8081 37.2175C31.2099 37.6574 30.709 38.216 30.3366 38.8584C28.9635 41.2773 31.8127 47.6461 30.2405 48.8521C28.6683 50.0582 23.6153 46.0785 21.6656 49.3098C20.3108 51.5571 20.6197 56.7108 20.9355 59.6538L24.6703 65.6953L43.0834 55.4498L31.8081 37.2175Z",
    fill: "#E2664C",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.952 41.9248C17.5608 42.9134 17.4097 44.0783 16.5859 44.5314C15.762 44.9845 14.6201 44.5497 14.009 43.5634C13.398 42.577 13.5513 41.4076 14.3752 40.9568C15.199 40.506 16.341 40.9293 16.952 41.9248Z",
    fill: "#E2664C",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.92 45.7604L24.0102 58.418L13.5221 28.1849L34.4319 15.5273L44.92 45.7604Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7325 45.2134L24.4703 56.8732L14.7077 28.7318L33.9721 17.072L43.7325 45.2134Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0161 25.8484C36.351 26.3584 35.773 26.9728 35.3043 27.6677C33.5308 30.3269 34.8604 37.1237 33.1463 38.4762C31.4322 39.8287 27.5555 35.6866 25.0657 39.2497C23.3402 41.7236 22.5484 47.2868 22.2463 50.4632L24.4707 56.871L43.7328 45.2112L37.0161 25.8484Z",
    fill: "#E2664C",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2142 31.3978C22.5781 32.4459 22.1821 33.7137 21.3331 34.2286C20.4841 34.7436 19.5023 34.3087 19.1362 33.2606C18.77 32.2125 19.1659 30.947 20.015 30.4321C20.864 29.9172 21.8503 30.3474 22.2142 31.3978Z",
    fill: "#E2664C",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7378 34.858L24.2719 45.9937L17.8001 12.1357L38.2637 1L44.7378 34.858Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7055 34.1234L24.8553 44.3827L18.8297 12.868L37.6822 2.61108L43.7055 34.1234Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5714 12.4377C38.8933 12.9227 38.3002 13.5166 37.8162 14.1953C35.9144 16.8476 36.4271 24.3355 34.7176 25.5896C33.0081 26.8437 29.8866 21.9075 27.2365 25.4523C25.4058 27.9124 24.1105 33.8167 23.4926 37.1991L24.8657 44.3826L43.7158 34.1234L39.5714 12.4377Z",
    fill: "#E2664C",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4265 16.6419C25.6554 17.8158 25.1588 19.134 24.328 19.5871C23.4973 20.0402 22.6391 19.4544 22.4149 18.2804C22.1906 17.1064 22.6826 15.7883 23.5133 15.3351C24.3441 14.882 25.2022 15.4679 25.4265 16.6419Z",
    fill: "#E2664C",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8249 38.9682L24.2709 72.0001L46.5126 58.7063L53.1675 26.3633L35.8254 36.7255L36.052 34.7437L27.8249 38.9682Z",
    fill: "#E2664C",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.8249 38.9682L24.2709 72.0001L46.5126 58.7063L53.1675 26.3633L35.8254 36.7255L36.052 34.7437L27.8249 38.9682Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureAlbum);
export default __webpack_public_path__ + "static/media/picture-album.e46f37e0713de37414f5d4f423319c7b.svg";
export { ForwardRef as ReactComponent };